function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "defaultOpen", "id", "onClose", "onOpen", "openOnFocus", "openOnHover", "placement", "tooltip", "transitionDelay", "transitionDuration", "triggerOffset", "type", "variantName", "wrapperProps"],
  _excluded2 = ["ref", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useRef, useState, useEffect, cloneElement } from 'react';
import { useHover, useLayer, Arrow } from 'react-laag';
import { Transition } from 'react-transition-group';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import { Placements } from "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import { TooltipTypes } from "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import 'styled-components';
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { transitionFadeIn } from "../../../../styles/transitions/fade-in.js";
import "../../../../utilities/color.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import { mergeRefs } from "../../../../utilities/refs.js";
import classes from "./styles/base-tooltip.module.scss.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var baseName = 'tooltip';
var BaseTooltip = function BaseTooltip(props) {
  var children = props.children,
    defaultOpen = props.defaultOpen,
    id = props.id,
    onClose = props.onClose,
    onOpen = props.onOpen,
    _props$openOnFocus = props.openOnFocus,
    openOnFocus = _props$openOnFocus === void 0 ? true : _props$openOnFocus,
    _props$openOnHover = props.openOnHover,
    openOnHover = _props$openOnHover === void 0 ? true : _props$openOnHover,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? Placements.TopCenter : _props$placement,
    tooltip = props.tooltip,
    _props$transitionDela = props.transitionDelay,
    transitionDelay = _props$transitionDela === void 0 ? 0 : _props$transitionDela,
    _props$transitionDura = props.transitionDuration,
    transitionDuration = _props$transitionDura === void 0 ? 200 : _props$transitionDura,
    _props$triggerOffset = props.triggerOffset,
    triggerOffset = _props$triggerOffset === void 0 ? 5 : _props$triggerOffset,
    _props$type = props.type,
    type = _props$type === void 0 ? TooltipTypes.Description : _props$type,
    variantName = props.variantName,
    wrapperProps = props.wrapperProps,
    otherProps = _objectWithoutProperties(props, _excluded);
  var nodeRef = useRef(null);
  var _useHover = useHover(),
    _useHover2 = _slicedToArray(_useHover, 2),
    isOver = _useHover2[0],
    hoverProps = _useHover2[1];
  var _useState = useState(defaultOpen || false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var isOpen = openOnHover && isOver || open;
  var handleKeyUp = function handleKeyUp(e) {
    var key = e.key;
    if (key === 'Escape') {
      setOpen(false);
    }
  };
  var handleOnClose = function handleOnClose() {
    if (onClose) {
      onClose();
    }
  };
  var handleOnOpen = function handleOnOpen() {
    if (onOpen) {
      onOpen();
    }
  };
  var _useLayer = useLayer({
      arrowOffset: 0,
      auto: true,
      containerOffset: 0,
      isOpen: isOpen,
      overflowContainer: true,
      placement: placement,
      triggerOffset: triggerOffset
    }),
    arrowProps = _useLayer.arrowProps,
    layerProps = _useLayer.layerProps,
    renderLayer = _useLayer.renderLayer,
    triggerProps = _useLayer.triggerProps;
  var ref = layerProps.ref,
    layerPropsStyle = layerProps.style,
    otherLayerProps = _objectWithoutProperties(layerProps, _excluded2);
  useEffect(function () {
    setOpen(defaultOpen || false);
  }, [defaultOpen]);
  var timeout = transitionDelay ? transitionDelay + transitionDuration : transitionDuration;
  return /*#__PURE__*/React.createElement("span", _extends({}, triggerProps, hoverProps, wrapperProps, {
    className: classnames("bf-".concat(baseName, "__").concat(variantName, "--wrapper"), wrapperProps && wrapperProps.className)
  }), /*#__PURE__*/cloneElement(children, {
    'aria-describedby': type === TooltipTypes.Description ? id : undefined,
    'aria-labelledby': type === TooltipTypes.Label ? id : undefined,
    onBlur: function onBlur() {
      if (openOnFocus) {
        setOpen(false);
        handleOnClose();
      }
    },
    onFocus: function onFocus() {
      if (openOnFocus) {
        setOpen(true);
        handleOnOpen();
      }
    },
    onKeyUp: function onKeyUp(e) {
      return handleKeyUp(e);
    }
  }), renderLayer( /*#__PURE__*/React.createElement(Transition, {
    appear: isOpen,
    in: isOpen,
    mountOnEnter: true,
    nodeRef: nodeRef,
    timeout: timeout,
    unmountOnExit: true
  }, function (transitionStatus) {
    return /*#__PURE__*/React.createElement("p", _extends({}, otherLayerProps, otherProps, {
      className: classnames("bf-".concat(baseName, "__").concat(variantName), otherProps && otherProps.className, classes['prefers-reduce-motion']),
      id: id,
      ref: mergeRefs([nodeRef, ref]),
      role: "tooltip",
      style: _objectSpread(_objectSpread({}, layerPropsStyle), transitionFadeIn({
        transitionDelay: transitionDelay,
        transitionDuration: transitionDuration,
        transitionStatus: transitionStatus
      }))
    }), tooltip, /*#__PURE__*/React.createElement(Arrow, _extends({
      onPointerEnterCapture: undefined,
      onPointerLeaveCapture: undefined
    }, arrowProps, {
      className: classnames("bf-".concat(baseName, "__").concat(variantName, "__arrow"), "bf-".concat(baseName, "__").concat(variantName, "__arrow--").concat(placement), classes.arrow)
    })));
  })));
};
export { BaseTooltip };